module.exports = "/_next/static/festival-pw.2033214d9360acc7b843ee4fc12ebd63.css";